import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  MmFlexLayoutModule
} from '@metromarkets/components';
import { PageLoadingComponent } from './page-loading.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    MmFlexLayoutModule
  ],
  declarations: [
    PageLoadingComponent,
  ],
  exports: [
    PageLoadingComponent
  ]
})

export class PageLoadingModule {}
